import React from "react";
import SubmitAndCancelButtons from "@/components/admin/SubmitAndCancelButtons";
import { Dialog, DialogContent, DialogOverlay, DialogTitle } from "@/components/atomic/Dialog";
import { cn } from "@/lib/utils";

interface ConfirmDialogProps {
  opened: boolean;
  title: string;
  message: string | React.ReactNode;
  confirmText?: string;
  confirmColor?: "blue" | "red";
  onConfirm: () => void;
  onClose: () => void;
  loading?: boolean;
  disabled?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  opened,
  title,
  message,
  confirmText = "OK",
  confirmColor = "blue",
  onConfirm,
  onClose,
  loading = false,
  disabled = false,
}) => {
  return (
    <Dialog open={opened} onOpenChange={onClose}>
      <DialogContent
        className={cn(
          "rounded-[10px] shadow-[0px_0px_10px_0px_rgba(0,0,0,0.25)] p-8 w-[524px] bg-white",
          "data-[state=closed]:slide-out-to-right-[0] data-[state=open]:slide-in-from-right-[0] z-1001",
        )}
      >
        <DialogTitle className="!m-0 !mb-8 !text-[22px] text-[#333333] leading-normal">{title}</DialogTitle>

        {/* 閉じるボタン */}
        <button
          data-testid="close-button"
          onClick={onClose}
          className="absolute right-4 top-4 w-[40px] h-[40px] bg-[#F3F3F4] rounded-full flex items-center justify-center hover:opacity-80 transition-opacity cursor-pointer"
          aria-label="Close modal"
        >
          <div className="relative w-4 h-4">
            <div className="absolute top-1/2 left-1/2 w-[20px] h-[3px] bg-[#868e96] transform -translate-x-1/2 -translate-y-1/2 rotate-45" />
            <div className="absolute top-1/2 left-1/2 w-[20px] h-[3px] bg-[#868e96] transform -translate-x-1/2 -translate-y-1/2 -rotate-45" />
          </div>
        </button>

        {/* メッセージ */}
        <div className="text-[14px] text-[#333333] mb-8">
          {message}
        </div>

        {/* ボタン */}
        <div className="flex gap-2 justify-end">
          <SubmitAndCancelButtons
            isLoading={loading || disabled}
            onCancel={onClose}
            onSubmit={onConfirm}
            submitButtonText={confirmText}
            submitButtonColor={confirmColor}
            buttonClassName="min-w-25"
          />
        </div>
      </DialogContent>
      <DialogOverlay className="bg-[rgba(0,0,0,0.5)] z-1000" />
    </Dialog>
  );
};

export default ConfirmDialog;
